import { render, staticRenderFns } from "./role_auth.vue?vue&type=template&id=a7dac89e&scoped=true&"
import script from "./role_auth.vue?vue&type=script&lang=js&"
export * from "./role_auth.vue?vue&type=script&lang=js&"
import style0 from "./role_auth.vue?vue&type=style&index=0&id=a7dac89e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dac89e",
  null
  
)

export default component.exports